<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="mb-6">
          <v-card-title>Profile</v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field v-model="profile.name" label="Name" />
              <v-text-field v-model="profile.email" label="Email" />
              <v-text-field v-model="profile.title" label="Job Title" />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" dark @click="saveProfile">Save changes</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="mb-6">
          <v-card-title>Notifications</v-card-title>
          <v-card-text>
            <v-switch v-model="notifications.updates" label="Product updates" />
            <v-switch v-model="notifications.reports" label="Weekly reports" />
            <v-switch v-model="notifications.billing" label="Billing alerts" />
            <v-checkbox v-model="notifications.digest" label="Send monthly digest" />
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>Security</v-card-title>
          <v-card-text>
            <v-select
              v-model="security.mfa"
              :items="mfaOptions"
              label="Multi-factor authentication"
            />
            <v-text-field
              v-model="security.sessionTimeout"
              label="Session timeout (minutes)"
              type="number"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="resetSecurity">Reset</v-btn>
            <v-spacer />
            <v-btn color="primary" dark @click="saveSecurity">Update security</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="toast" timeout="2200" color="success" top right>
      {{ toastMessage }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'SettingsView',
  data: () => ({
    toast: false,
    toastMessage: '',
    profile: {
      name: 'Alicia Keys',
      email: 'alicia@example.com',
      title: 'Operations Lead',
    },
    notifications: {
      updates: true,
      reports: true,
      billing: false,
      digest: true,
    },
    security: {
      mfa: 'Authenticator app',
      sessionTimeout: 30,
    },
    defaults: {
      security: {
        mfa: 'Authenticator app',
        sessionTimeout: 30,
      },
    },
    mfaOptions: ['Authenticator app', 'SMS code', 'Security key'],
  }),
  methods: {
    notify(message) {
      this.toastMessage = message
      this.toast = true
    },
    saveProfile() {
      this.notify('Profile updated')
    },
    saveSecurity() {
      this.notify('Security settings saved')
    },
    resetSecurity() {
      this.security = { ...this.defaults.security }
      this.notify('Security settings reset')
    },
  },
}
</script>
